module.exports = __webpack_public_path__ + "img/sprinkle-20.f05a9d68.jpg";